import { MODAL_DASHBOARD, MODAL_LOGIN, MODAL_SIGNUP, MODAL_UPGRADE, PLAN_PROFESSIONAL } from '../../constants/app';
import * as params from '../../constants/params';

export const UPDATE_QUERYSTRING = 'ROUTER/UPDATE_QUERYSTRING';

export const updateQueryString = (payload, replaceHistory) => ({
  type: UPDATE_QUERYSTRING,
  payload: {
    ...payload,
    replaceHistory,
  },
});

export const showDashboardModal = () => updateQueryString({ modal: MODAL_DASHBOARD });

export const showDashboardModalEdit = () =>
  updateQueryString({ modal: MODAL_DASHBOARD, [params.EDIT_DASHBOARD]: true });

export const hideDashboardModal = () => updateQueryString({ modal: undefined, [params.EDIT_DASHBOARD]: undefined });

export const showLoginModal = () => updateQueryString({ modal: MODAL_LOGIN });

export const showSignupModal = () => updateQueryString({ modal: MODAL_SIGNUP });

export const showUpgradeModal = (value) => updateQueryString({ modal: MODAL_UPGRADE, [params.UPGRADE_PLAN]: value });

export const showUpgradeModalProfessional = () => showUpgradeModal(PLAN_PROFESSIONAL);

export const updateResolutionUrl = (value) => updateQueryString({ [params.RESOLUTION]: value });

export const resetZoom = () =>
  updateQueryString({
    [params.ZOOM]: 'all',
    [params.SINCE]: undefined,
    [params.UNTIL]: undefined,
    [params.DATE]: undefined,
  });

export const resetMovingMath = () =>
  updateQueryString({ [params.MOVING_AVERAGE]: undefined, [params.MOVING_MEDIAN]: undefined });
